import React, { Fragment } from 'react'
import './detail-body.css'

export default ({ hit }) => (
  <Fragment>
    {hit.html && hit.html !== 'undefined'
      ? <div className='detail-body-wrapper' dangerouslySetInnerHTML={{ __html: hit.html }} />
      : null
    }
  </Fragment>
)
